import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en.json';
import pl from './pl.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'pl',
    fallbackLocale: 'pl',
    messages: {
        en,
        pl,
    }
});

export default i18n;